<template>
  <div v-on="listeners">
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { TouchMixin } from './touch_mixin'

  export default Vue.extend({
    mixins: [TouchMixin],

    props: {
      index: {
        type: Number,
        default: 0,
      },
      total: {
        type: Number,
        default: 0,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      listeners() {
        if (this.disabled) return {}
        return {
          touchstart: this.touchStart,
          touchmove: this.touchMove,
          touchend: this.onTouchEnd,
          touchcancel: this.onTouchEnd,
        }
      },
    },

    methods: {
      onTouchEnd() {
        const { direction, deltaX, offsetX } = this
        if (direction === 'horizontal' && offsetX >= 50) {
          if (deltaX > 0) {
            this.$emit('swipe', {
              direction: 'left',
              isLeft: true,
              isRight: false,
              index: Math.max(0, this.index - 1),
            })
          } else if (deltaX < 0) {
            this.$emit('swipe', {
              direction: 'right',
              isLeft: false,
              isRight: true,
              index: Math.min(this.total - 1, this.index + 1),
            })
          }
        }
      },
    },
  })
</script>
